import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import close from '../assets/images/colosePopup.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: 0,
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    maxWidth: 820,
    width: '100%',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    padding: '4px 24px 24px 24px',
  },
  title: {
    color: '#181818',
    fontFamily: 'Inter, sans-serif',
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 600,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 12,
    marginBottom: 16,
    borderBottom: '1px solid #DFE4EB',
    '& input': {
      width: 36,
      height: 36,
      borderRadius: 999,

      background: '#F2F2F2',
      boxSizing: 'border-box',
    },
  },
  body: {
    overflowY: 'auto',
    paddingRight: 4,
  },
  typeHead: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 700,
    color: '#1B3963',
  },
  typeDetail: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '22px',
    color: '#475569',
  },
})

const PortfolioTooltipModal = ({
  open,
  setOpen,
  handleClose,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth={false}
        PaperProps={{ style: { maxWidth: 820, width: '100%' } }}
      >
        <DialogContent>
          <div className={classes.content}>
            <div className={classes.header}>
              <div>
                <span className={classes.title}>Portfolio</span>
              </div>
              <input
                type="image"
                onClick={() => handleClose()}
                src={close}
                alt="closeBtn"
              />
            </div>
            <div className={classes.body}>
              <div className={classes.detailContent}>
                <span className={classes.typeHead}>Portfolio: </span>
                <span className={classes.typeDetail}>
                  This is a high level view of your current portfolio, displayed
                  as a heat-map, each round “marble” represents a company and
                  each colour represents a risk status, high risk = red, orange
                  = medium risk, yellow = low risk and grey = neutral
                </span>
              </div>
              <div className={classes.detailContent}>
                <span className={classes.typeDetail}>
                  Risk has different attributes depending on the capital
                  structure of the company, the toggle on the top bar allows you
                  to navigate between the risk outlook specific to equity or
                  credit. This allows you to have a complete 360 view of the
                  risk across your current portfolio of companies.
                </span>
              </div>
              <div className={classes.detailContent}>
                <span className={classes.typeDetail}>
                  You can navigate the different risk status by clicking on the
                  corresponding “risk circles” on the right hand side or the
                  “risk pie” on the left hand side of the portfolio panel. If
                  you hover over a company marble a tool tip will be visible to
                  give you the basic information around the company. Double
                  click on a company marble to navigate to the full company risk
                  report. On the top bar of the portfolio panel you will see a
                  “week to date” tab, if you click on this you can see the
                  companies which have had a changed risk status over the last
                  rolling 7 days. You can see this from an increasing risk,
                  where the risk has increased and also from a decreasing risk
                  where the risk has normalised. You can also look at this from
                  both an equity and credit risk perspective. There is a quick %
                  risk panel on the right hand-side of the panel which allows
                  you a quick view of the percentage of the portfolio which is
                  on a particular risk status.
                </span>
              </div>
              <div className={classes.detailContent}>
                <span className={classes.typeHead}>Portfolio List: </span>
                <span className={classes.typeDetail}>
                  You can also view your portfolio from the Portfolio List
                  panel, this gives you a much more granular view. There are a
                  series of filters which allow you to filter by; risk status,
                  sector, region and country. There are also a second level of
                  filters which allow you to sort each column by either
                  alphabetical or chronological order. On the far left you can
                  see the previous status to the current status, to allow you to
                  see the evolution of the company risk. There is also a
                  specific search box, which allows you to quickly search for a
                  company within your portfolio. On the far right as you hover
                  over the company there is a “delete” icon, this allows you to
                  delete a company from your portfolio. At any moment if you
                  click on a company you can navigate to the full company risk
                  report. On the risk report page you can also search for
                  companies outside of your portfolio and use the “add to
                  portfolio” button to add the company into your portfolio.
                </span>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(PortfolioTooltipModal)
